<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher<{ click: MouseEvent }>();

  export let disabled = false;
  export let loading = false;
  export let isSubmitButton = false;
  export let width = '100%';
  export let flex: number | null = 1;

  export let border: string = '1px solid var(--magic-potion)';
  export let borderRadius: string = '128px';
  export let color: string = 'white';
  export let background: string = 'linear-gradient(180deg, #F93964 0%, #EA0639 100%)';
  export let backgroundActive: string = background;

  export let text = '';
  export let fontSize: string = 'var(--md-font-size)';
  export let fontWeight: string = 'var(--medium-font-weight)';
  export let lineHeight: string = '21px';

  export let boxShadow = '0px -1px 1px 0px #0000001a inset, 0px 2px 1px 0px #ffffff1a inset';

  export let leftImage = '';
  export let leftImageHeight = '';
  export let leftImageWidth = '';
  export let leftImageClass = '';
  export let leftImageMarginBottom = '';
  export let rightImage = '';
  export let rightImageHeight = '';
  export let rightImageWidth = '';
  export let rightImageClass = '';
  export let imageClass = '';
  export let imageWidth = '24px';
  export let imageHeight = '24px';
  export let imageMarginLeft = '4px';
  export let imageMarginRight = '4px';

  export let spaceBetween = false;

  export let paddingTop: string = '16px';
  export let paddingBottom: string = '24px';
  export let paddingLeft: string = '16px';
  export let paddingRight: string = '24px';

  export let marginTop: string = '0px';
  export let marginBottom: string = '0px';
  export let marginLeft: string = '0px';
  export let marginRight: string = '0px';

  export let widthMobile = width;
  export let borderMobile = border;
  export let colorMobile = color;
  export let backgroundMobile = background;
  export let backgroundActiveMobile = backgroundActive;
  export let fontSizeMobile = fontSize;
  export let fontWeightMobile = fontWeight;
  export let leftImageHeightMobile = leftImageHeight;
  export let leftImageWidthMobile = leftImageWidth;
  export let rightImageHeightMobile = rightImageHeight;
  export let rightImageWidthMobile = rightImageWidth;
  export let imageWidthMobile = imageWidth;
  export let imageHeightMobile = imageHeight;
  export let imageMarginLeftMobile = imageMarginLeft;
  export let imageMarginRightMobile = imageMarginRight;
  export let paddingTopMobile = paddingTop;
  export let paddingBottomMobile = paddingBottom;
  export let paddingLeftMobile = paddingLeft;
  export let paddingRightMobile = paddingRight;
  export let marginTopMobile = marginTop;
  export let marginBottomMobile = marginBottom;
  export let marginLeftMobile = marginLeft;
  export let marginRightMobile = marginRight;

  export let onClick = () => {};

  if (border === '1px solid var(--magic-potion)' && background === 'var(--magic-potion)') {
    border = '1px solid #0000001a';
    borderMobile = border;
  }
  if (background === 'var(--magic-potion)') {
    background = 'linear-gradient(180deg, #F93964 0%, #EA0639 100%)';
    backgroundMobile = background;
  }
</script>

<button
  type={isSubmitButton ? 'submit' : 'button'}
  class="cta params"
  {disabled}
  style="
    box-shadow: {boxShadow};

    justify-content: {spaceBetween ? 'space-between' : 'center'}; 
    {flex !== null ? `flex: ${flex};` : ''}
    
    --button-padding-top: {paddingTop};
    --button-padding-bottom: {paddingBottom};
    --button-padding-left: {paddingLeft};
    --button-padding-right: {paddingRight};
    --button-font-size: {fontSize};
    --button-font-weight: {fontWeight};
    --button-line-height: {lineHeight};
    --button-width: {width};
    --button-margin-top: {marginTop};
    --button-margin-bottom: {marginBottom};
    --button-margin-left: {marginLeft};
    --button-margin-right: {marginRight};
    --button-border: {border};
    --button-border-radius: {borderRadius};
    --button-color: {color};
    --button-background: {background};
    --button-active-background: {backgroundActive};
    --button-box-shadow: {boxShadow};

    --button-width-mobile: {widthMobile};
    --button-border-mobile: {borderMobile};
    --button-color-mobile: {colorMobile};
    --button-background-mobile: {backgroundMobile};
    --button-active-background-mobile: {backgroundActiveMobile};
    --button-font-size-mobile: {fontSizeMobile};
    --button-font-weight-mobile: {fontWeightMobile};
    --button-padding-top-mobile: {paddingTopMobile};
    --button-padding-bottom-mobile: {paddingBottomMobile};
    --button-padding-left-mobile: {paddingLeftMobile};
    --button-padding-right-mobile: {paddingRightMobile};
    --button-margin-top-mobile: {marginTopMobile};
    --button-margin-bottom-mobile: {marginBottomMobile};
    --button-margin-left-mobile: {marginLeftMobile};
    --button-margin-right-mobile: {marginRightMobile};
    "
  on:click={(event) => {
    dispatch('click', event);
    onClick();
  }}
>
  {#if leftImage}
    <img
      class={'image-params ' + (leftImageClass || imageClass)}
      src={leftImage}
      alt=""
      aria-hidden="true"
      loading="lazy"
      class:rotate={loading}
      style="
        --button-image-width: {leftImageWidth || imageWidth};
        --button-image-height: {leftImageHeight || imageHeight};
        --button-image-margin-right: {imageMarginRight};
        --button-image-margin-bottom: {leftImageMarginBottom};

        --button-image-width-mobile: {leftImageWidthMobile || imageWidthMobile};
        --button-image-height-mobile: {leftImageHeightMobile || imageHeightMobile};
        --button-image-margin-right-mobile: {imageMarginRightMobile};
      "
    />
  {/if}
  <slot />
  {text}
  {#if rightImage}
    <img
      class={'image-params ' + (rightImageClass || imageClass)}
      src={rightImage}
      alt=""
      aria-hidden="true"
      loading="lazy"
      class:rotate={loading}
      style="
        --button-image-width: {rightImageWidth || imageWidth};
        --button-image-height: {rightImageHeight || imageHeight};
        --button-image-margin-left: {imageMarginLeftMobile};

        --button-image-width-mobile: {rightImageWidthMobile || imageWidthMobile};
        --button-image-height-mobile: {rightImageHeightMobile || imageHeightMobile};
        --button-image-margin-left-mobile: {imageMarginLeftMobile};
      "
    />
  {/if}
</button>

<style>
  .params {
    padding-top: var(--button-padding-top);
    padding-bottom: var(--button-padding-bottom);
    padding-left: var(--button-padding-left);
    padding-right: var(--button-padding-right);
    font-size: var(--button-font-size);
    line-height: var(--button-line-height);
    width: var(--button-width);
    margin-top: var(--button-margin-top);
    margin-bottom: var(--button-margin-bottom);
    margin-left: var(--button-margin-left);
    margin-right: var(--button-margin-right);
    background: var(--button-background);
    border: var(--button-border);
    color: var(--button-color);
    font-weight: var(--button-font-weight);
    box-shadow: var(--button-box-shadow);
  }

  .rotate {
    animation: rotation 2s infinite linear;
  }

  button[disabled] {
    cursor: default;
    opacity: 0.6;
  }

  .image-params {
    width: var(--button-image-width);
    height: var(--button-image-height);
    margin-right: var(--button-image-margin-right);
    margin-left: var(--button-image-margin-left);
    margin-bottom: var(--button-image-margin-bottom);
  }

  .cta {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: var(--button-border-radius);
    transition: transform 0.2s;
    white-space: nowrap;
  }

  .cta:hover {
    transform: scale(1.03);
  }

  .cta:hover:disabled {
    transform: none;
  }

  .cta:active {
    transform: scale(1.01);
    background: var(--button-active-background);
  }

  @media (max-width: 900px) {
    .cta {
      font-size: var(--base-font-size);
    }

    .params {
      padding-top: var(--button-padding-top-mobile);
      padding-bottom: var(--button-padding-bottom-mobile);
      padding-left: var(--button-padding-left-mobile);
      padding-right: var(--button-padding-right-mobile);
      font-size: var(--button-font-size-mobile);
      width: var(--button-width-mobile);
      margin-top: var(--button-margin-top-mobile);
      margin-bottom: var(--button-margin-bottom-mobile);
      margin-left: var(--button-margin-left-mobile);
      margin-right: var(--button-margin-right-mobile);
      background: var(--button-background-mobile);
      border: var(--button-border-mobile);
      color: var(--button-color-mobile);
      font-weight: var(--button-font-weight-mobile);
    }

    .cta:active {
      background: var(--button-active-background-mobile);
    }

    .image-params {
      width: var(--button-image-width-mobile);
      height: var(--button-image-height-mobile);
      margin-right: var(--button-image-margin-right-mobile);
      margin-left: var(--button-image-margin-left-mobile);
    }
  }
</style>
